import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TFAMethodTypes } from '../enums/tfa-types';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationAdapter {
  private http = inject(HttpClient);

  editPassword(payload): Observable<any> {
    return this.http.patch(`${environment.apiBaseUrl}/company/user/password`, payload);
  }

  register(payload: { email: string; password: string; captchaCode?: string; selfOnboarded: boolean; utmSource: string; utmCampaign: string; utmMedium: string }): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/register`, payload);
  }

  login(credentials: { email: string; password: string; tfa?: string }): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/login`, credentials);
  }

  logout(): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/logout`, {});
  }

  passwordReset(payload): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/password-reset`, payload);
  }

  setPassword(payload): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/set-password`, payload);
  }

  sendEmailVerification(payload): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/send-email-verification`, payload);
  }

  emailVerification(payload): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/email-verification`, payload);
  }

  getAuthenticationMethods(
    emailOrNonce: string,
    isNonce: boolean
  ): Observable<{ types: TFAMethodTypes[] }> {
    const param: string = isNonce ? `nonce=${emailOrNonce}` : `email=${emailOrNonce}`;
    return this.http.get<{ types: TFAMethodTypes[] }>(
      `${environment.apiBaseUrl}/company/auth/login-authentication-methods?${param}`
    );
  }

  refreshToken(polling: boolean = false): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/refresh-token`, {
      polling,
    });
  }

  getCookieForToken(refreshToken: string): Observable<any> {
    const params = new HttpParams().set('refreshToken', refreshToken);
    return this.http.get(`${environment.apiBaseUrl}/company/auth/cookie-for-token`, { params });
  }

  signInWithGoogle(token: string): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/auth/google-authentication`, {
      token,
    });
  }
}
